module.exports = __webpack_public_path__ + "img/sina.ce245a94.png";